import {EventBase} from "shared/utilities/Events/EventManager";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";

export class DuplicateFieldEvent extends EventBase {
    ReturnType: void;

    constructor(public options:PDFControlBaseOptions,public id:number) {
        super();
    }

    public static GetName() {
        return 'DuplicateFieldEvent';
    }
}